export { default } from './CookieConsentBar';
